import { toast } from 'react-toastify';

/**
 * Convierte un PDF en base64 a Blob y abre el diálogo de impresión del navegador.
 * Usa un iframe oculto con Blob URL - abre el diálogo de impresión sin nueva ventana.
 *
 * @param {string} pdfBase64 - El PDF codificado en base64 (sin el prefijo data:)
 * @returns {void}
 */
export function imprimirPDFDirecto(pdfBase64) {
  if (!pdfBase64) {
    toast.error('No hay PDF para imprimir');
    return;
  }

  try {
    // Convertir base64 a Blob
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);

    // Crear iframe oculto para imprimir (no abre nueva ventana)
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    iframe.src = blobUrl;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (e) {
          console.error('Error al llamar print:', e);
          toast.error('Error al abrir diálogo de impresión');
        }
      }, 100);

      // Limpiar iframe y Blob URL después de que el usuario cierre el diálogo
      setTimeout(() => {
        document.body.removeChild(iframe);
        URL.revokeObjectURL(blobUrl);
      }, 60000);
    };

    iframe.onerror = () => {
      toast.error('Error al cargar el PDF para imprimir');
      document.body.removeChild(iframe);
      URL.revokeObjectURL(blobUrl);
    };

  } catch (error) {
    console.error('Error al imprimir PDF:', error);
    toast.error('Error al imprimir el PDF');
  }
}
